<template>
	<div class="element-logo is-empty">
		<div class="avatar" v-if="logo">
			<img :src="logo" class="w-100" :class="{ 'rounded-circle': rounded }" />
		</div>
	</div>
</template>

<script>
import store from '../../store'
export default {
	props: {
		definition: { type: Object, required: true },
		element: { type: Object, required: true },
	},
	computed: {
		logo() {
			return this.definition.options && this.definition.options.type && this.definition.options.type == 'USER' ?
				store.state.info.user.logo : store.state.info.company.logo
		},
		rounded() {
			return this.definition.options && this.definition.options.class && this.definition.options.class == 'rounded'
		}
	}
}
</script>
